import { Component, Vue, Watch } from 'vue-property-decorator';
import { proxyfetch } from 'tivigi/src/util/proxyfetch';
import { tryToRead } from 'tivigi/src/util/tryToRead';
import Data from 'tivigi/src/components/data/Data/Data'

import WithRender from './SM3Base.html';
import '../statistikmonitor.scss'

@WithRender
@Component({
    components: { Data }
})
export default class SM3Base extends Vue {

    spatialUnits = new Array<any>()
    indicators: any = {}

    categories = [
        "Volksw. Gesamtrechnung",
        "Beschäftigte (SvB)",
        "Arbeitsmarkt",
        "SGB II-Grundsicherung",
        "Bevölkerung",
        "Bevölkerungsprognose 2040",
        "Flächennutzung",
        "Wohnen",
        "Schulbildung"
    ]

    local:any = {}



    getCategoriesWithIndicatorTypes(itypes: Array<string>): Array<string> {


        const indiType = itypes[0]

        let result = Array<string>()

        for (let c of this.categories) {

            if (result.includes(c)) {
                continue
            }

            if (this.getIndicators(c, indiType).length > 0) {
                result.push(c)
            }
        }

        return result
    }


    getCssClass(spatialUnit: any): string {

        if (spatialUnit == null) {
            console.error("getCssClass(): Spatial unit is null")
            return ""
        }

        if (spatialUnit.properties.id == "urn:ngsi-ld:Metropolregion:RheinNeckar") {
            return "compare-mrn"
        }


        return "";
    }



    getSpatialUnitsDefault(): Array<any> {
        let result = Array<any>()


        // Deutschland:
        result.push(this.getSpatialUnit("urn:ngsi-ld:Staat:Deutschland"))

        // Die 3 Länder:
        result.push(this.getSpatialUnit("urn:ngsi-ld:Bundesland:08"))
        result.push(this.getSpatialUnit("urn:ngsi-ld:Bundesland:06"))

        result.push(this.getSpatialUnit("urn:ngsi-ld:Bundesland:07"))

        // MRN:
        result.push(this.getSpatialUnit("urn:ngsi-ld:Metropolregion:RheinNeckar"))


        result = result.concat(this.getSpatialUnits(['K']))
        return result
    }




    getGlossaryLink(icode: string): string {

        const indicator = this.getIndicator(icode)

        if (indicator == null || indicator == undefined) {
            console.log("Indicator not found: " + icode)
            return ""
        }

        return indicator.glossary_url
    }



    getIndicator(indicatorCode: string): any | null {


        return this.indicators[indicatorCode]


    }


    getLatestYear(su: any, indicatorCode: string): string | any {

        let years = Array<any>();

        for (let key in su.properties) {

            if ((key as string).startsWith(indicatorCode)) {

                // ATTENTION: This assumes that there is only one '_' in the 
                // key and that the part after the '_' is the year!
                let pair = key.split('_')

                if (pair.length == 2) {
                    let year = pair[1]

                    if (year != null && !years.includes(year)) {
                        years.push(year)
                    }
                }
            }
        }

        if (years.length > 0) {
            return years.sort()[years.length - 1]
        }

        return null
    }


    getSpatialUnit(suid: string): any {
        for (let su of this.spatialUnits) {
            if (su.properties.id == suid) {
                return su
            }
        }

        return null
    }


    getSpatialUnits(types: Array<string>) {
        let result = Array<any>()

        for (let su of this.spatialUnits) {
            if (su.properties.type == undefined) {
                console.log("ERROR")
                console.log(su.properties)
                continue
            }
            if (types.includes(su.properties.type.toUpperCase())) {
                result.push(su)
            }
        }

        return result.sort((a, b) => { if (a.properties.name > b.properties.name) return 1; if (a.properties.name < b.properties.name) return -1; return 0; })
    }


    getValue(spatialUnit: any, indicatorCode: string, year: any) {

        return spatialUnit.properties[indicatorCode + "_" + year]
    }


    getYears(indicatorCode: any) {

        let result = Array<any>()

        for (let su of this.spatialUnits) {

            for (let key in su.properties) {
                if ((key as string).startsWith(indicatorCode)) {

                    // ATTENTION: This assumes that there is only one '_' in the 
                    // key and that the part after the '_' is the year!
                    let pair = key.split('_')

                    if (pair.length == 2) {

                        if (!result.includes(pair[1])) {
                            result.push(pair[1])
                        }
                    }
                }
            }
        }

        return result.sort((a, b) => { if (a < b) return 1; if (a > b) return -1; return 0; })
    }


    getIndicators(category: string | null, type: string): Array<any> {

        let result = Array<any>()

        for (let code in this.indicators) {

            const indicator = this.indicators[code]

            if (indicator.type != type) {
                continue
            }

            if (category == null || indicator.category == category) {
                result.push(indicator)
            }

        }

        return result
    }


    getIndicatorDisplayDate(indicator: any, selectedYear: any): string {
        let result = selectedYear

        if (indicator.month != -1) {
            result += "/" + indicator.month
        }

        return result
    }



    getTopIndicators(): Array<any> {

        let result = Array<any>()

        for (let code in this.indicators) {
            const indicator = this.indicators[code]

            if (indicator.is_top_indicator) {

                result.push(indicator)

            }
        }


        return result
    }


    /*
    indicatorsExistFor(category: string, itype: string): boolean {
        return this.getIndicators(category, itype).length > 0
    }
    */


    created() {

        let p1 = proxyfetch("statistikmonitor3/allinone.json").then(response => response.json())
        let p2 = proxyfetch("statistikmonitor3/indicators.json").then(response => response.json())

        Promise.all([p1, p2]).then(this.onDataLoaded2)
    }


    onDataLoaded2(data_array: any) {


        this.spatialUnits = data_array[0].features
        this.indicators = data_array[1]
    }


    print() {
        window.print()
    }


    openGlossary(url: string) {
        window.open(url)
    }



    tryToRead(root: any, path: string) {
        return tryToRead(root, path, undefined)
    }
}


